<mat-form-field
    *ngIf="!hideOnEmptyList || this.herkunftFuerGruppe.length > 0 || this.isLoading"
    class="abgang-form-input no-padding-margin-mat-form-field"
    style="margin: 6px 0 0 0; width: 100%"
>
    <mat-icon style="padding-right: 6px" matPrefix>search</mat-icon>
    <mat-label>{{ label }}</mat-label>
    <mat-select multiple [compareWith]="compareHerkunft" [formControl]="selectedHerkunftCtrl">
        <mat-option *ngFor="let herkunft of herkunftFuerGruppe" [value]="herkunft"
            >{{ displayLabel(herkunft) }} ({{ herkunft.anzahl }} Tiere)</mat-option
        >
    </mat-select>
    <button
        *ngIf="selectedHerkunftCtrl.value && herkunftFuerGruppe.length > 0"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="resetHerkunftCtrl($event)"
    >
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>
